import { useTranslation } from 'react-i18next';
import { FolderOpen, Megaphone } from 'lucide-react';
import { Page, PageContent, Tabs, TabsContent, TabsList, TabsTrigger } from '@bliks-io/ui';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { MaterialsTab } from './materials/MaterialsTab';
import { NewsTab } from './news/NewsTab';

/** The superadmin's mini CMS for what every partner sees: Info Hub material and home page news. */
export function PartnerContentPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('partnerContent.title'));

  return (
    <Page>
      <PageContent>
        <div className="mb-6">
          <h1 className="text-3xl font-bold tracking-tight">{t('partnerContent.title')}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{t('partnerContent.description')}</p>
        </div>

        <Tabs defaultValue="materials">
          <TabsList>
            <TabsTrigger value="materials">
              <span className="flex items-center gap-2">
                <FolderOpen className="h-4 w-4" />
                {t('partnerContent.tabs.materials')}
              </span>
            </TabsTrigger>
            <TabsTrigger value="news">
              <span className="flex items-center gap-2">
                <Megaphone className="h-4 w-4" />
                {t('partnerContent.tabs.news')}
              </span>
            </TabsTrigger>
          </TabsList>
          <TabsContent value="materials" className="mt-4">
            <MaterialsTab />
          </TabsContent>
          <TabsContent value="news" className="mt-4">
            <NewsTab />
          </TabsContent>
        </Tabs>
      </PageContent>
    </Page>
  );
}
